import * as z from 'zod';

// Select agent form schema
export const agentSchema = z.object({
  agent: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .refine(data => data.value.length > 0, 'Please select an agent'),
});

export type AgentFormData = z.infer<typeof agentSchema>;

// Agent voice form schema
export const agentVoiceSchema = z.object({
  voice: z.object({
    value: z.string(),
    label: z.string(),
  }),
});

export type AgentVoiceFormData = z.infer<typeof agentVoiceSchema>;

// Timezone form schema
export const timezoneSchema = z.object({
  timezone: z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .refine(data => data.value.length > 0, 'Please select a timezone'),
});

export type TimezoneFormData = z.infer<typeof timezoneSchema>;

// Website URL form schema
export const websiteUrlSchema = z.object({
  websiteUrl: z
    .string()
    .optional()
    .refine(val => {
      if (!val) {
        return true;
      } // Optional field
      // Simple URL validation
      try {
        const url = new URL(val);
        return url.protocol === 'http:' || url.protocol === 'https:';
      } catch {
        return false;
      }
    }, 'Please enter a valid URL (starting with http:// or https://)'),
});

export type WebsiteUrlFormData = z.infer<typeof websiteUrlSchema>;

export interface ParsedState {
  rid?: string;
  restaurant_name?: string;
  restaurant_location?: string;
  workspace_id?: string;
}

export type UiStage =
  | 'idle'
  | 'creating'
  | 'linking'
  | 'redirecting'
  | 'getting_projects';

export type OpenTableAgentConfig = {
  agentName?: string;
  voiceId?: string;
  projectId: string | null;
  isNewProject: boolean;
  timezone?: string;
  websiteUrl?: string;
};

export type FailedStep =
  | 'updateIntegration'
  | 'redirecting'
  | 'gettingProjects';

export type RetryCtx = {
  step: FailedStep;
};

export type RequestParam = {
  name: string;
  value: string | null;
};

export type AgentSetupStep =
  | 'selectAgent'
  | 'selectVoice'
  | 'selectTimezone'
  | 'websiteUrl';
